import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteDayOfWeekSlice = createSlice({
  name: 'DeleteDayOfWeek',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteDayOfWeek: (state, _) => {
      state.isLoading = true;
    },
    successDeleteDayOfWeek: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteDayOfWeek: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteDayOfWeek: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteDayOfWeek,
  failureDeleteDayOfWeek,
  successDeleteDayOfWeek,
  clearDeleteDayOfWeek,
} = DeleteDayOfWeekSlice.actions;

export default DeleteDayOfWeekSlice.reducer;
